import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { ResponsePaginated } from 'crono-fe-common/types/response';
import { Account } from 'crono-fe-common/types/account';
import { AccountGetParameters } from 'crono-fe-common/types/DTO/accountGetParameters';

export default function useAccounts<TData = ResponsePaginated<Account[]>>(
  searchParameters: AccountGetParameters,
  offset = 0,
  enabled = true,
  select?: (data: ResponsePaginated<Account[]>) => TData,
) {
  const params: {
    limit: string;
    offset: string;
    name?: string;
    status?: string;
    sort?: string;
    view?: string;
    isManager?: string;
  } = {
    limit: searchParameters.limit?.toString(),
    offset: offset?.toString(),
  };

  if (searchParameters.name) {
    params.name = searchParameters.name;
  }
  if (searchParameters.status) {
    params.status = searchParameters.status;
  }

  if (searchParameters.Sort) {
    params.sort = searchParameters.Sort;
  }

  if (searchParameters.View) {
    params.view = searchParameters.View;
  }

  if (searchParameters.isManager) {
    params.isManager = 'true';
  }

  let statusQuery;
  if (searchParameters.Status) {
    statusQuery = searchParameters.Status.reduce(
      (prev, curr) => prev + `Status=${curr}&`,
      '&',
    ).slice(0, -1);
  }

  const queryString = new URLSearchParams(params).toString();

  const request: Request = {
    url: ENDPOINTS.account.main + '?' + queryString + (statusQuery ?? ''),
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.account.main, queryString + (statusQuery ?? '')],

    queryFn: () => client(request),
    enabled,
    select,
  };

  return useQuery<ResponsePaginated<Account[]>, CronoError, TData>(
    requestConfig,
  );
}
